// @ts-nocheck

import { createSelector } from 'reselect';

import {
  getCashoutAllowedFromProps,
  getCashoutValueFromProps,
  getCompleteBetAllowedFromProps,
} from '../../selectors/_propsGetters_';
import { selectBasketStatus } from '../../selectors/basket/basketPrimary.selector';
import { selectIsBetslipCashout } from '../../selectors/cashout/cashoutPrimary.selector';
import { selectEntitiesBets } from '../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesBetslipsEntity } from '../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { selectEntitiesOutcomes } from '../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { BasketStatuses } from '../../types/basket';
import { BetslipTypes } from '../../types/history';
import { type Selector } from '../../types/selectors';

type HistoryItemCashOutButtonsPropsType = {
  isCompleteBetDisabled: boolean;
  isCashoutAvailable: boolean;
  isCompleteBetAvailable: boolean;
};

const selectIsCompleteBetDisabled: Selector<boolean> = createSelector(
  [selectBasketStatus],
  (basketStatus) => basketStatus === BasketStatuses.PENDING,
);

const selectIsCashoutAvailable: Selector<boolean> = createSelector(
  [getCashoutAllowedFromProps, getCashoutValueFromProps],
  (cashoutAllowed, cashoutValue) => cashoutAllowed && !!cashoutValue,
);

const selectIsCompleteBetAvailable: Selector<boolean> = createSelector(
  [
    getCompleteBetAllowedFromProps,
    selectEntitiesBetslipsEntity,
    selectIsBetslipCashout,
    selectEntitiesOutcomes,
    selectEntitiesBets,
  ],
  (completeBetAllowed, betslip, cashoutStatus, outcomes, bets) => {
    if (!completeBetAllowed) {
      return false;
    }

    let isCompleteBetAvailable = false;
    if (
      betslip &&
      // Only single and multiple
      [BetslipTypes.SINGLE, BetslipTypes.MULTIPLE].indexOf(betslip.type) !== -1 &&
      // No cashout request in progress
      (cashoutStatus === undefined || cashoutStatus === null)
    ) {
      // Check that there is no outcomes flagged with hasOccured and equals to false
      isCompleteBetAvailable = betslip.details.every((x) => {
        const outcome = outcomes[x.outcomeId];
        if (outcome) {
          if (outcome.hasOccured !== false) {
            return true;
          }
          const bet = bets[outcome.betId];
          if (bet && bet.isCancelled) {
            return true;
          }
        }
        return false;
      });
    }

    return isCompleteBetAvailable;
  },
);

const selectHistoryItemCashoutButtonsProps: Selector<HistoryItemCashOutButtonsPropsType> = createSelector(
  [selectIsCompleteBetDisabled, selectIsCashoutAvailable, selectIsCompleteBetAvailable],
  (isCompleteBetDisabled, isCashoutAvailable, isCompleteBetAvailable) => ({
    isCompleteBetDisabled,
    isCashoutAvailable,
    isCompleteBetAvailable,
  }),
);

export default selectHistoryItemCashoutButtonsProps;
